import { render, staticRenderFns } from "./ZskModal.vue?vue&type=template&id=1687fb67&scoped=true&"
import script from "./ZskModal.vue?vue&type=script&lang=js&"
export * from "./ZskModal.vue?vue&type=script&lang=js&"
import style0 from "./ZskModal.vue?vue&type=style&index=0&id=1687fb67&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1687fb67",
  null
  
)

export default component.exports